import { action } from 'satcheljs';

export let validateDumpsterQuota = action('TRY_VALIDATE_DUMPSTER_QUOTA', (folderId: string) => ({
    folderId,
}));
